import React, { useState } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { EmotionSection } from '../components/EmotionSection';
import { RegenerativeSection } from '../components/RegenerativeSection';
import { HowItWorks } from '../components/HowItWorks';
import { BeforeAfterSection } from '../components/BeforeAfterSection';
import { TestimonialCarousel } from '../components/TestimonialCarousel';
import { FAQAccordion } from '../components/FAQAccordion';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { ConsultationModal } from '../components/ConsultationModal';
import { StickyCallBar } from '../components/StickyCallBar';
export function BBLForeverYoung() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <div className="min-h-screen flex flex-col w-full bg-brand-bg selection:bg-brand-gold/20 selection:text-brand-text pb-14" data-id="element-186">
      <Header onOpenModal={() => setIsModalOpen(true)} data-id="element-187" />
      <main className="flex-grow flex flex-col w-full" data-id="element-188">
        <HeroSection onOpenModal={() => setIsModalOpen(true)} data-id="element-189" />
        <BeforeAfterSection onOpenModal={() => setIsModalOpen(true)} data-id="element-190" />
        <TrustBar data-id="element-191" />
        <EmotionSection data-id="element-192" />
        <RegenerativeSection data-id="element-193" />
        <HowItWorks data-id="element-194" />
        <TestimonialCarousel data-id="element-195" />
        <FAQAccordion data-id="element-196" />
        <FinalCTA onOpenModal={() => setIsModalOpen(true)} data-id="element-197" />
      </main>
      <Footer data-id="element-198" />
      <ConsultationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-199" />
      <StickyCallBar data-id="element-200" />
    </div>;
}